import React from "react";
import MessageHeader from "./MessageHeader";

const MessageImage = ({
  fromClient,
  messageSentTime,
  userData,
  imageUrl,
}: {
  fromClient: boolean;
  messageSentTime: number;
  userData: any;
  imageUrl: string;
}) => {
  return (
    <div className={`message ${fromClient ? "right" : "left"}`}>
      <MessageHeader
        fromClient={fromClient}
        messageSentTime={messageSentTime}
        userData={userData}
      />
      <img
        src={imageUrl}
        alt=""
        style={{ height: "auto", width: "auto", borderRadius: "10px" }}
      />
    </div>
  );
};

export default MessageImage;
